import { useEffect, useState } from 'react'
import style from './QuestIcon.module.css'
import Wheel from '/Wheel.webp'
import { formatTime } from '../../Services/utils.js'

export default function QuestIcon() {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    function calculateTimeLeft() {
        const now = new Date();
        const endOfDay = new Date();
        endOfDay.setUTCHours(24, 0, 0, 0);
        return Math.floor((endOfDay - now) / 1000);
    }

    useEffect(() => {
        const timer = setInterval(() => {
            const newTimeLeft = calculateTimeLeft();
            setTimeLeft(newTimeLeft);

            if (newTimeLeft < 1) {
                setTimeLeft(24 * 60 * 60);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className={style['container']}>
            <div className={style['wheel-wrapper']}>
                <img 
                    src={Wheel} 
                    alt="wheel" 
                />
            </div>
            <div className={style['timer-wrapper']}>
                <div className={style['timer-text']}>
                    {formatTime(timeLeft)}
                </div>
            </div>
        </div>
    );
}